import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import css from "./OrdersListInfoModal.module.css";
import { DefaultInfoBlockModal } from "../DefaultInfoBlockModal/DefaultInfoBlockModal";
import { ordersActions } from "../../../../store/slices/orders-slices";

const OrdersListInfoModal = ({ selectedPack, setObj, obj }) => {
  const dispatch = useDispatch();
  const { menuDishesPacksForDates, currentPrice } = useSelector(
    (store) => store.orders
  );

  // update obj if selectedPack changes
  useEffect(() => {
    const updatedPacks = menuDishesPacksForDates.flatMap(
      (pack) =>
        pack.packs
          .filter((p) => p.id === selectedPack)
          .map((p) => ({ ...p, date: pack.date })) // Додаємо дату до об'єкта
    );

    setObj(updatedPacks);
  }, [menuDishesPacksForDates, selectedPack]);

  // Оновлюємо Redux state з ціною
  useEffect(() => {
    if (obj.length > 0) {
      const totalPrice = obj.reduce(
        (sum, pack) => sum + (pack.pricePerDay || 0),
        0
      );

      if (currentPrice !== totalPrice) {
        dispatch(ordersActions.changeCurrentPrice(totalPrice));
      }
    }
  }, [obj, dispatch, currentPrice]);

  return (
    <div className={css.wrap}>
      {obj.map((pack) => (
        <DefaultInfoBlockModal
          key={pack.date}
          singlePack={[pack]}
          dataOfDay={pack.date}
          setObj={setObj}
        />
      ))}
    </div>
  );
};

export default React.memo(OrdersListInfoModal);
